export default __webpack_public_path__ + "26ae19f5aa5611b9213ca8b4b0f1247f.svg";